import api from './api';

// Pick the most recent financial year from a /core/financial-years/ response.
// FY docs are returned unordered; sort by end_date (ISO string), then created_at, then label.
const newestFY = (fys) =>
  [...fys].sort((a, b) => {
    const key = (fy) => fy.end_date || fy.created_at || fy.label || '';
    return String(key(b)).localeCompare(String(key(a)));
  })[0];

// Set the JWT context to a company + its most recent financial year, and persist
// the re-scoped tokens (same localStorage keys the consultant app uses).
export async function setClientContext(companyId) {
  const { data: fys } = await api.get(`/core/financial-years/?company_id=${companyId}`);
  if (!fys || fys.length === 0) {
    const err = new Error('No financial years have been set up for this company yet. Contact your consultant.');
    err.code = 'NO_FY';
    throw err;
  }
  const fy = newestFY(fys);
  const { data } = await api.post('/core/set-context/', {
    company_id: companyId,
    financial_year_id: fy.id,
  });
  localStorage.setItem('access_token', data.access);
  localStorage.setItem('refresh_token', data.refresh);
  localStorage.setItem('company_id', companyId);
  localStorage.setItem('financial_year_id', fy.id);
  return { companyId, financialYear: fy };
}

// On login the client app has no context. Load the companies this user belongs to
// (usually one), set context to the stored/first one, and report the list so the
// header can offer a switcher when there is more than one.
export async function bootstrapClientContext() {
  const { data: companies } = await api.get('/core/companies/');
  if (!companies || companies.length === 0) {
    return { companies: [] };
  }
  const stored = localStorage.getItem('company_id');
  const chosen = companies.find((c) => c.id === stored) || companies[0];
  const { financialYear } = await setClientContext(chosen.id);
  return { companies, companyId: chosen.id, financialYear };
}
